import { c as _c } from "react/compiler-runtime";
import { TextHelper } from "@sticker-giant/sg-frontend-common";
import type { PackagingMode } from "@/utils/resolvePackagingMode";
import type { RollDriver } from "@/utils/rollQuantityUtils";
interface Props {
  packageCount: number;
  quantityPerPackage: number;
  packagingMode: PackagingMode;
  rollDriver?: RollDriver;
}
export const packagingQuantitySelectTriggerClass = "*:[span]:first:w-full";
export const packagingQuantitySelectItemClass = "*:[span]:last:w-full";
export default function PackagingQuantityOption(t0) {
  const $ = _c(19);
  const {
    packageCount,
    quantityPerPackage,
    packagingMode,
    rollDriver: t1
  } = t0;
  const rollDriver = t1 === undefined ? null : t1;
  const showPackageCount = rollDriver !== "ROLL_QTY";
  const showQuantityPerPackage = rollDriver === "ROLL_QTY" || rollDriver === null;
  let labels;
  if ($[0] !== packageCount || $[1] !== packagingMode || $[2] !== quantityPerPackage || $[3] !== showPackageCount || $[4] !== showQuantityPerPackage) {
    labels = [];
    if (showPackageCount) {
      let t2;
      if ($[6] !== packageCount) {
        t2 = packageCount.toLocaleString();
        $[6] = packageCount;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      let t3;
      if ($[8] !== packageCount) {
        t3 = TextHelper.pluralize(packageCount, "", "s");
        $[8] = packageCount;
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      labels.push(`${t2} ${packagingMode}${t3}`);
    }
    if (showQuantityPerPackage && quantityPerPackage) {
      let t2;
      if ($[10] !== quantityPerPackage) {
        t2 = quantityPerPackage.toLocaleString();
        $[10] = quantityPerPackage;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      labels.push(`${t2} items/${packagingMode}`);
    }
    $[0] = packageCount;
    $[1] = packagingMode;
    $[2] = quantityPerPackage;
    $[3] = showPackageCount;
    $[4] = showQuantityPerPackage;
    $[5] = labels;
  } else {
    labels = $[5];
  }
  const t2 = labels.join(", ");
  let t3;
  if ($[12] !== t2) {
    t3 = <span className="sr-only">{t2}</span>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== labels) {
    t4 = <span aria-hidden="true" className="flex w-full items-center gap-4 tabular-nums">{labels.map(_temp)}</span>;
    $[14] = labels;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp(label) {
  return <span key={label} className="text-left font-medium">{label}</span>;
}